import yr from "@emotion/styled";
import { CacheProvider as gr, ThemeContext as br, css as mr, keyframes as vr } from "@emotion/react";
import "react";
import { P as tr } from "./index-057d60ee.js";
import { jsx as wr } from "react/jsx-runtime";
import { G as kr } from "./GlobalStyles-bdd9f9fb.js";
import { _ as G } from "./extends-0a3e0827.js";
import { _ as Er } from "./objectWithoutPropertiesLoose-1e2b28af.js";
import { p as xr, i as _r } from "./createTheme-ef7fa3a1.js";
function $r(r) {
  if (r.sheet)
    return r.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === r)
      return document.styleSheets[e];
}
function Pr(r) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", r.key), r.nonce !== void 0 && e.setAttribute("nonce", r.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var Ar = /* @__PURE__ */ function() {
  function r(n) {
    var t = this;
    this._insertTag = function(i) {
      var s;
      t.tags.length === 0 ? t.insertionPoint ? s = t.insertionPoint.nextSibling : t.prepend ? s = t.container.firstChild : s = t.before : s = t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(i, s), t.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = r.prototype;
  return e.hydrate = function(t) {
    t.forEach(this._insertTag);
  }, e.insert = function(t) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Pr(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = t.charCodeAt(0) === 64 && t.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + t + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var h = $r(i);
      try {
        h.insertRule(t, h.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(t) && console.error('There was a problem inserting the following rule: "' + t + '"', f);
      }
    } else
      i.appendChild(document.createTextNode(t));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(t) {
      return t.parentNode && t.parentNode.removeChild(t);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, r;
}(), w = "-ms-", q = "-moz-", a = "-webkit-", Q = "comm", X = "rule", rr = "decl", Nr = "@import", cr = "@keyframes", Sr = "@layer", Or = Math.abs, U = String.fromCharCode, Cr = Object.assign;
function Rr(r, e) {
  return b(r, 0) ^ 45 ? (((e << 2 ^ b(r, 0)) << 2 ^ b(r, 1)) << 2 ^ b(r, 2)) << 2 ^ b(r, 3) : 0;
}
function or(r) {
  return r.trim();
}
function Tr(r, e) {
  return (r = e.exec(r)) ? r[0] : r;
}
function c(r, e, n) {
  return r.replace(e, n);
}
function H(r, e) {
  return r.indexOf(e);
}
function b(r, e) {
  return r.charCodeAt(e) | 0;
}
function V(r, e, n) {
  return r.slice(e, n);
}
function A(r) {
  return r.length;
}
function er(r) {
  return r.length;
}
function F(r, e) {
  return e.push(r), r;
}
function Ir(r, e) {
  return r.map(e).join("");
}
var K = 1, T = 1, fr = 0, x = 0, p = 0, I = "";
function B(r, e, n, t, i, s, h) {
  return { value: r, root: e, parent: n, type: t, props: i, children: s, line: K, column: T, length: h, return: "" };
}
function M(r, e) {
  return Cr(B("", null, null, "", null, null, 0), r, { length: -r.length }, e);
}
function Dr() {
  return p;
}
function Mr() {
  return p = x > 0 ? b(I, --x) : 0, T--, p === 10 && (T = 1, K--), p;
}
function _() {
  return p = x < fr ? b(I, x++) : 0, T++, p === 10 && (T = 1, K++), p;
}
function N() {
  return b(I, x);
}
function W() {
  return x;
}
function z(r, e) {
  return V(I, r, e);
}
function j(r) {
  switch (r) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ur(r) {
  return K = T = 1, fr = A(I = r), x = 0, [];
}
function hr(r) {
  return I = "", r;
}
function L(r) {
  return or(z(x - 1, Z(r === 91 ? r + 2 : r === 40 ? r + 1 : r)));
}
function Vr(r) {
  for (; (p = N()) && p < 33; )
    _();
  return j(r) > 2 || j(p) > 3 ? "" : " ";
}
function jr(r, e) {
  for (; --e && _() && !(p < 48 || p > 102 || p > 57 && p < 65 || p > 70 && p < 97); )
    ;
  return z(r, W() + (e < 6 && N() == 32 && _() == 32));
}
function Z(r) {
  for (; _(); )
    switch (p) {
      case r:
        return x;
      case 34:
      case 39:
        r !== 34 && r !== 39 && Z(p);
        break;
      case 40:
        r === 41 && Z(r);
        break;
      case 92:
        _();
        break;
    }
  return x;
}
function zr(r, e) {
  for (; _() && r + p !== 47 + 10; )
    if (r + p === 42 + 42 && N() === 47)
      break;
  return "/*" + z(e, x - 1) + "*" + U(r === 47 ? r : _());
}
function Fr(r) {
  for (; !j(N()); )
    _();
  return z(r, x);
}
function Wr(r) {
  return hr(Y("", null, null, null, [""], r = ur(r), 0, [0], r));
}
function Y(r, e, n, t, i, s, h, f, y) {
  for (var m = 0, d = 0, v = h, S = 0, C = 0, k = 0, o = 1, E = 1, l = 1, g = 0, $ = "", D = i, O = s, P = t, u = $; E; )
    switch (k = g, g = _()) {
      case 40:
        if (k != 108 && b(u, v - 1) == 58) {
          H(u += c(L(g), "&", "&\f"), "&\f") != -1 && (l = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        u += L(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        u += Vr(k);
        break;
      case 92:
        u += jr(W() - 1, 7);
        continue;
      case 47:
        switch (N()) {
          case 42:
          case 47:
            F(Lr(zr(_(), W()), e, n), y);
            break;
          default:
            u += "/";
        }
        break;
      case 123 * o:
        f[m++] = A(u) * l;
      case 125 * o:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            E = 0;
          case 59 + d:
            l == -1 && (u = c(u, /\f/g, "")), C > 0 && A(u) - v && F(C > 32 ? sr(u + ";", t, n, v - 1) : sr(c(u, " ", "") + ";", t, n, v - 2), y);
            break;
          case 59:
            u += ";";
          default:
            if (F(P = nr(u, e, n, m, d, i, f, $, D = [], O = [], v), s), g === 123)
              if (d === 0)
                Y(u, e, P, P, D, s, v, f, O);
              else
                switch (S === 99 && b(u, 3) === 110 ? 100 : S) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Y(r, P, P, t && F(nr(r, P, P, 0, 0, i, f, $, i, D = [], v), O), i, O, v, f, t ? D : O);
                    break;
                  default:
                    Y(u, P, P, P, [""], O, 0, f, O);
                }
        }
        m = d = C = 0, o = l = 1, $ = u = "", v = h;
        break;
      case 58:
        v = 1 + A(u), C = k;
      default:
        if (o < 1) {
          if (g == 123)
            --o;
          else if (g == 125 && o++ == 0 && Mr() == 125)
            continue;
        }
        switch (u += U(g), g * o) {
          case 38:
            l = d > 0 ? 1 : (u += "\f", -1);
            break;
          case 44:
            f[m++] = (A(u) - 1) * l, l = 1;
            break;
          case 64:
            N() === 45 && (u += L(_())), S = N(), d = v = A($ = u += Fr(W())), g++;
            break;
          case 45:
            k === 45 && A(u) == 2 && (o = 0);
        }
    }
  return s;
}
function nr(r, e, n, t, i, s, h, f, y, m, d) {
  for (var v = i - 1, S = i === 0 ? s : [""], C = er(S), k = 0, o = 0, E = 0; k < t; ++k)
    for (var l = 0, g = V(r, v + 1, v = Or(o = h[k])), $ = r; l < C; ++l)
      ($ = or(o > 0 ? S[l] + " " + g : c(g, /&\f/g, S[l]))) && (y[E++] = $);
  return B(r, e, n, i === 0 ? X : f, y, m, d);
}
function Lr(r, e, n) {
  return B(r, e, n, Q, U(Dr()), V(r, 2, -2), 0);
}
function sr(r, e, n, t) {
  return B(r, e, n, rr, V(r, 0, t), V(r, t + 1, -1), t);
}
function R(r, e) {
  for (var n = "", t = er(r), i = 0; i < t; i++)
    n += e(r[i], i, r, e) || "";
  return n;
}
function Yr(r, e, n, t) {
  switch (r.type) {
    case Sr:
      if (r.children.length)
        break;
    case Nr:
    case rr:
      return r.return = r.return || r.value;
    case Q:
      return "";
    case cr:
      return r.return = r.value + "{" + R(r.children, t) + "}";
    case X:
      r.value = r.props.join(",");
  }
  return A(n = R(r.children, t)) ? r.return = r.value + "{" + n + "}" : "";
}
function qr(r) {
  var e = er(r);
  return function(n, t, i, s) {
    for (var h = "", f = 0; f < e; f++)
      h += r[f](n, t, i, s) || "";
    return h;
  };
}
function Ur(r) {
  return function(e) {
    e.root || (e = e.return) && r(e);
  };
}
var Kr = function(e, n, t) {
  for (var i = 0, s = 0; i = s, s = N(), i === 38 && s === 12 && (n[t] = 1), !j(s); )
    _();
  return z(e, x);
}, Br = function(e, n) {
  var t = -1, i = 44;
  do
    switch (j(i)) {
      case 0:
        i === 38 && N() === 12 && (n[t] = 1), e[t] += Kr(x - 1, n, t);
        break;
      case 2:
        e[t] += L(i);
        break;
      case 4:
        if (i === 44) {
          e[++t] = N() === 58 ? "&\f" : "", n[t] = e[t].length;
          break;
        }
      default:
        e[t] += U(i);
    }
  while (i = _());
  return e;
}, Gr = function(e, n) {
  return hr(Br(ur(e), n));
}, ir = /* @__PURE__ */ new WeakMap(), Hr = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, t = e.parent, i = e.column === t.column && e.line === t.line; t.type !== "rule"; )
      if (t = t.parent, !t)
        return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !ir.get(t)) && !i) {
      ir.set(e, !0);
      for (var s = [], h = Gr(n, s), f = t.props, y = 0, m = 0; y < h.length; y++)
        for (var d = 0; d < f.length; d++, m++)
          e.props[m] = s[y] ? h[y].replace(/&\f/g, f[d]) : f[d] + " " + h[y];
    }
  }
}, Zr = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, Jr = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Qr = function(e) {
  return e.type === "comm" && e.children.indexOf(Jr) > -1;
}, Xr = function(e) {
  return function(n, t, i) {
    if (!(n.type !== "rule" || e.compat)) {
      var s = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var h = !!n.parent, f = h ? n.parent.children : (
          // global rule at the root level
          i
        ), y = f.length - 1; y >= 0; y--) {
          var m = f[y];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (Qr(m))
              return;
            break;
          }
        }
        s.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, dr = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, re = function(e, n) {
  for (var t = e - 1; t >= 0; t--)
    if (!dr(n[t]))
      return !0;
  return !1;
}, ar = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, ee = function(e, n, t) {
  dr(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), ar(e)) : re(n, t) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), ar(e)));
};
function lr(r, e) {
  switch (Rr(r, e)) {
    case 5103:
      return a + "print-" + r + r;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + r + r;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + r + q + r + w + r + r;
    case 6828:
    case 4268:
      return a + r + w + r + r;
    case 6165:
      return a + r + w + "flex-" + r + r;
    case 5187:
      return a + r + c(r, /(\w+).+(:[^]+)/, a + "box-$1$2" + w + "flex-$1$2") + r;
    case 5443:
      return a + r + w + "flex-item-" + c(r, /flex-|-self/, "") + r;
    case 4675:
      return a + r + w + "flex-line-pack" + c(r, /align-content|flex-|-self/, "") + r;
    case 5548:
      return a + r + w + c(r, "shrink", "negative") + r;
    case 5292:
      return a + r + w + c(r, "basis", "preferred-size") + r;
    case 6060:
      return a + "box-" + c(r, "-grow", "") + a + r + w + c(r, "grow", "positive") + r;
    case 4554:
      return a + c(r, /([^-])(transform)/g, "$1" + a + "$2") + r;
    case 6187:
      return c(c(c(r, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), r, "") + r;
    case 5495:
    case 3959:
      return c(r, /(image-set\([^]*)/, a + "$1$`$1");
    case 4968:
      return c(c(r, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + w + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + r + r;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return c(r, /(.+)-inline(.+)/, a + "$1$2") + r;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (A(r) - 1 - e > 6)
        switch (b(r, e + 1)) {
          case 109:
            if (b(r, e + 4) !== 45)
              break;
          case 102:
            return c(r, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3$1" + q + (b(r, e + 3) == 108 ? "$3" : "$2-$3")) + r;
          case 115:
            return ~H(r, "stretch") ? lr(c(r, "stretch", "fill-available"), e) + r : r;
        }
      break;
    case 4949:
      if (b(r, e + 1) !== 115)
        break;
    case 6444:
      switch (b(r, A(r) - 3 - (~H(r, "!important") && 10))) {
        case 107:
          return c(r, ":", ":" + a) + r;
        case 101:
          return c(r, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (b(r, 14) === 45 ? "inline-" : "") + "box$3$1" + a + "$2$3$1" + w + "$2box$3") + r;
      }
      break;
    case 5936:
      switch (b(r, e + 11)) {
        case 114:
          return a + r + w + c(r, /[svh]\w+-[tblr]{2}/, "tb") + r;
        case 108:
          return a + r + w + c(r, /[svh]\w+-[tblr]{2}/, "tb-rl") + r;
        case 45:
          return a + r + w + c(r, /[svh]\w+-[tblr]{2}/, "lr") + r;
      }
      return a + r + w + r + r;
  }
  return r;
}
var te = function(e, n, t, i) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case rr:
        e.return = lr(e.value, e.length);
        break;
      case cr:
        return R([M(e, {
          value: c(e.value, "@", "@" + a)
        })], i);
      case X:
        if (e.length)
          return Ir(e.props, function(s) {
            switch (Tr(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return R([M(e, {
                  props: [c(s, /:(read-\w+)/, ":" + q + "$1")]
                })], i);
              case "::placeholder":
                return R([M(e, {
                  props: [c(s, /:(plac\w+)/, ":" + a + "input-$1")]
                }), M(e, {
                  props: [c(s, /:(plac\w+)/, ":" + q + "$1")]
                }), M(e, {
                  props: [c(s, /:(plac\w+)/, w + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, ne = [te], se = function(e) {
  var n = e.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var t = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(t, function(o) {
      var E = o.getAttribute("data-emotion");
      E.indexOf(" ") !== -1 && (document.head.appendChild(o), o.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || ne;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var s = {}, h, f = [];
  h = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(o) {
      for (var E = o.getAttribute("data-emotion").split(" "), l = 1; l < E.length; l++)
        s[E[l]] = !0;
      f.push(o);
    }
  );
  var y, m = [Hr, Zr];
  process.env.NODE_ENV !== "production" && m.push(Xr({
    get compat() {
      return k.compat;
    }
  }), ee);
  {
    var d, v = [Yr, process.env.NODE_ENV !== "production" ? function(o) {
      o.root || (o.return ? d.insert(o.return) : o.value && o.type !== Q && d.insert(o.value + "{}"));
    } : Ur(function(o) {
      d.insert(o);
    })], S = qr(m.concat(i, v)), C = function(E) {
      return R(Wr(E), S);
    };
    y = function(E, l, g, $) {
      d = g, process.env.NODE_ENV !== "production" && l.map !== void 0 && (d = {
        insert: function(O) {
          g.insert(O + l.map);
        }
      }), C(E ? E + "{" + l.styles + "}" : l.styles), $ && (k.inserted[l.name] = !0);
    };
  }
  var k = {
    key: n,
    sheet: new Ar({
      key: n,
      container: h,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: s,
    registered: {},
    insert: y
  };
  return k.sheet.hydrate(f), k;
};
let J;
typeof document == "object" && (J = se({
  key: "css",
  prepend: !0
}));
function pr(r) {
  const {
    injectFirst: e,
    children: n
  } = r;
  return e && J ? /* @__PURE__ */ wr(gr, {
    value: J,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (pr.propTypes = {
  /**
   * Your component tree.
   */
  children: tr.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: tr.bool
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function ie(r, e) {
  const n = yr(r, e);
  return process.env.NODE_ENV !== "production" ? (...t) => {
    const i = typeof r == "string" ? `"${r}"` : "component";
    return t.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : t.some((s) => s === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...t);
  } : n;
}
const ae = (r, e) => {
  Array.isArray(r.__emotion_styles) && (r.__emotion_styles = e(r.__emotion_styles));
}, me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: kr,
  StyledEngineProvider: pr,
  ThemeContext: br,
  css: mr,
  default: ie,
  internal_processStyles: ae,
  keyframes: vr
}, Symbol.toStringTag, { value: "Module" })), ce = ["sx"], oe = (r) => {
  var e, n;
  const t = {
    systemProps: {},
    otherProps: {}
  }, i = (e = r == null || (n = r.theme) == null ? void 0 : n.unstable_sxConfig) != null ? e : xr;
  return Object.keys(r).forEach((s) => {
    i[s] ? t.systemProps[s] = r[s] : t.otherProps[s] = r[s];
  }), t;
};
function ve(r) {
  const {
    sx: e
  } = r, n = Er(r, ce), {
    systemProps: t,
    otherProps: i
  } = oe(n);
  let s;
  return Array.isArray(e) ? s = [t, ...e] : typeof e == "function" ? s = (...h) => {
    const f = e(...h);
    return _r(f) ? G({}, t, f) : t;
  } : s = G({}, t, e), G({}, i, {
    sx: s
  });
}
export {
  me as a,
  ve as e,
  ae as i,
  ie as s
};
//# sourceMappingURL=extendSxProp-10687d60.js.map
